<script setup>
import BpmnSpeed from "@/components/BpmnSpeed.vue";
import OperationLog from "@/components/OperationLog.vue";
import { ref, reactive, nextTick } from "vue";
import {
  queryMyInitiativeById,
  getBackNodes,
  startFormInfo,
  taskOperationLog,
  historyFormData,
} from "@/api/myInitiative";
// 弹窗显隐
const visible = ref(false);

// 弹窗遮罩
const loading = ref(false);

// 表单ref
const vFormRef = ref(null);

// tabs默认选中pane
const activeName = ref("form");

// 流程字符串
const xmlStr = ref("");

// 流程id
const instanceId = ref(null);

const bpmnSpeed = ref(null);

const businessKey = ref("");

const operationLog = ref([]);

const starter = ref("");

const backNodes = ref([]);

const definitionName = ref("");

const startForm = reactive({
  startFormConf: {
    fields: [],
    formRef: "elForm",
    formModel: "formData",
    size: "medium",
    labelPosition: "right",
    labelWidth: 100,
    formRules: "rules",
    gutter: 15,
    disabled: false,
    span: 24,
    formBtns: false,
  },
  formData: {},
  taskId: "",
});

const getTaskOperationLog = () => {
  taskOperationLog(instanceId.value).then((res) => {
    const arr = res.data.value;
    const newOperationLog = [];
    for (let i = 0; i < arr.length; i++) {
      var log = arr[i];
      newOperationLog.push(eval(`(${log})`));
    }
    newOperationLog.map((i) => {
      i = JSON.parse(i);
    });

    operationLog.value = newOperationLog;
  });
};

const initStartForm = () => {
  startFormInfo(instanceId.value).then((res) => {
    const obj = res.data;
    console.log("res", res.data);
    if (obj.formContent) {
      startForm.startFormConf = JSON.parse(obj.formContent);
      startForm.taskId = obj.taskId;
      historyFormData(startForm.taskId)
        .then((res) => {
          startForm.formData = convertToJsonObj(res.data);
          vFormRef.value.setFormJson(startForm.startFormConf);
        })
        .finally(() => {
          vFormRef.value.disableForm();
          vFormRef.value.setFormData(startForm.formData);
        });
    }
  });
};

const viewForm = () => {
  loading.value = true;
  queryMyInitiativeById(instanceId.value)
    .then((res) => {
      const obj = res.data;
      starter.value = obj.starter;
      definitionName.value = obj.definitionName;
      xmlStr.value = obj.xmlStr;
      businessKey.value = obj.businessKey;
      initBackNodes();
      initStartForm();
      getTaskOperationLog();
    })
    .finally(() => {
      loading.value = false;
    });
};

const initBackNodes = () => {
  getBackNodes(instanceId.value).then((res) => {
    let arr = res.data;
    for (let i = 0; i < arr.length; i++) {
      backNodes.value.push({
        value: arr[i].activityId,
        label: arr[i].activityName,
      });
    }
  });
};

const convertToJsonObj = (arr) => {
  let obj = {};
  if (!Array.isArray(arr)) {
    return obj;
  }
  for (let i = 0; i < arr.length; i++) {
    let current = arr[i];
    obj[current.name] = current.textValue;
  }
  return obj;
};

const resetBpmn = (tab, event) => {
  if (tab.index == "1") {
    bpmnSpeed.value?.resetBpmn();
  }
};

// 弹窗打开
const handleDialogOpen = (id) => {
  instanceId.value = id;
  viewForm();
  visible.value = true;
};

defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    title="流程实例详情"
    width="55%"
    :close-on-click-modal="false"
    v-model="visible"
  >
    <div v-loading="loading">
      <el-row :gutter="10" class="top_title">
        <el-col :span="3">
          <span>提交人： {{ starter }}</span>
        </el-col>
        <el-col :span="17">
          <span>流程名称： {{ definitionName }}</span>
        </el-col>
      </el-row>

      <el-tabs v-model="activeName" type="border-card" @tab-click="resetBpmn">
        <el-tab-pane label="表单信息" name="form">
          <div class="h_title">流程发起表单</div>
          <v-form-render
            :form-json="startForm.startFormConf"
            :form-data="startForm.formData"
            ref="vFormRef"
          />
        </el-tab-pane>
        <el-tab-pane label="进度查看" name="process">
          <bpmn-speed
            ref="bpmnSpeed"
            :xmlStr="xmlStr"
            :instanceId="instanceId"
          />
        </el-tab-pane>
        <el-tab-pane label="提交记录" name="records">
          <operation-log :operationLog="operationLog" :backnodes="backNodes" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<style scoped>
.top_title {
  margin-bottom: 15px;
}

.startForm-container {
  padding: 10px 10%;
  min-height: calc(100vh - 75px);
  background-color: #f3f3f3;
  margin-top: -10px;
}
.header {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  margin: 10px 0;
  padding: 20px 20px;
  /*box-shadow: 1px 1px 3px rgb(0 0 0 / 20%);*/
  overflow: hidden;
}
.formDiv {
  width: 100%;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 20px;
  overflow: hidden;
}
.header > div {
  line-height: 34px;
}
.act-btn-tool {
  text-align: right;
}
.h-title {
  border-left: 5px solid #1a7bb9;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
.h-title-red {
  border-left: 5px solid red;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
.split {
  height: 0px;
  border-bottom: 2px #ccc;
  border-bottom-style: dashed;
  margin: 0 4%;
}
</style>
